// @flow
import isEqual from 'react-fast-compare';
import Mobile from './Mobile/Mobile';
import React from 'react';
import Seo from './Seo/Seo';
import styles from './LAFooter.module.scss';
import Support from './Support/Support';
import Trust from './Trust/Trust';

type Props = {
    baseUrl: string,
    classicBaseUrl: string,
    mobileBrowserOS: string,
    openDownloadMobileModal: Function,
    openFeedbackModal: Function,
    openHealthcheckModal: Function,
    trackClassicLinkClick: Function,
    windowWidth: number,
    year: number,
};

const LAFooter = (props: Props) => {
    const {
        baseUrl,
        classicBaseUrl,
        mobileBrowserOS,
        openDownloadMobileModal,
        openFeedbackModal,
        openHealthcheckModal,
        trackClassicLinkClick,
        windowWidth,
        year,
    } = props;

    return (
        <div className={styles.footer}>
            <Mobile mobileBrowserOS={mobileBrowserOS} windowWidth={windowWidth} />
            <Trust />
            <Seo />
            <Support
                baseUrl={baseUrl}
                classicBaseUrl={classicBaseUrl}
                openDownloadMobileModal={openDownloadMobileModal}
                openFeedbackModal={openFeedbackModal}
                openHealthcheckModal={openHealthcheckModal}
                trackClassicLinkClick={trackClassicLinkClick}
                year={year}
            />
        </div>
    );
};

export default React.memo<Props>(LAFooter, isEqual);
